import { render } from "./AussenLeistungenPage.vue?vue&type=template&id=28499c05"
import script from "./AussenLeistungenPage.vue?vue&type=script&lang=js"
export * from "./AussenLeistungenPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__